module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Forgot Password")]), _vm._v(" "), (_vm.loadStatus === 'error') ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.passwordError))])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canSubmit) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "reset-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "reset-email",
      "type": "text",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "value": "Reset Password"
    },
    on: {
      "click": _vm.reset
    }
  })])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b4da76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 278
// module chunks = 1